import { render, staticRenderFns } from "./RequestFundsTableUser.vue?vue&type=template&id=10f2a05b&scoped=true"
import script from "./RequestFundsTableUser.vue?vue&type=script&lang=js"
export * from "./RequestFundsTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f2a05b",
  null
  
)

export default component.exports